import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { createElement } from 'react';
import { styled, css } from '@moonpig/launchpad-utils';
import { all, sizingSpacing, system, flexbox, spacing } from '@moonpig/launchpad-system';
import { colorValue } from '@moonpig/launchpad-theme';
import styled$1, { createGlobalStyle } from 'styled-components';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
var StyledAspectRatio = styled.div.withConfig({
  displayName: "StyledAspectRatio",
  componentId: "rwwvy6-0"
})(["position:relative;::before{display:block;height:0;content:'';padding-bottom:", ";}> img{height:auto;}>:first-child{position:absolute;top:0;left:0;width:100%;height:100%;}"], function (_ref) {
  var ratio = _ref.ratio;
  return "".concat(1 / ratio * 100, "%");
});

var AspectRatio = function AspectRatio(_ref2) {
  var children = _ref2.children,
      _ref2$ratio = _ref2.ratio,
      ratio = _ref2$ratio === void 0 ? 1 : _ref2$ratio,
      props = _objectWithoutProperties(_ref2, ["children", "ratio"]);

  return createElement(StyledAspectRatio, _extends({
    ratio: ratio
  }, props), children);
};
/**
 * @component
 */


var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "sc-1xyn5ag-0"
})(["", ""], all);
var COMPONENT_HEIGHT = '48px';
var StyledButtonBase = styled.button.withConfig({
  displayName: "StyledButtonBase",
  componentId: "uyd427-0"
})(["", ";", " min-height:", ";padding:0 1rem;"], sizingSpacing, system({
  typography: 'ctaButton'
}), COMPONENT_HEIGHT);
var StyledButtonContained = styled(StyledButtonBase).withConfig({
  displayName: "StyledButtonContained",
  componentId: "uyd427-1"
})(["border:none;color:", ";background-color:", ";&:hover,&:focus{background-color:", ";}&:active{background-color:", ";}&:disabled{background-color:", ";color:", ";}"], colorValue('onCta'), colorValue('cta'), colorValue('ctaActive'), function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, function (props) {
  return props.theme.colors.palette.eclipse.l80;
}, colorValue('text'));
var StyledButtonOutlined = styled(StyledButtonBase).withConfig({
  displayName: "StyledButtonOutlined",
  componentId: "uyd427-2"
})(["background-color:transparent;border:2px solid ", ";color:", ";&:hover,&:focus{border-color:", ";color:", ";}&:active{border-color:", ";color:", ";}&:disabled{border-color:", ";color:", ";}"], colorValue('text'), colorValue('text'), colorValue('cta'), colorValue('cta'), function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, colorValue('placeholder'), colorValue('placeholder'));
var StyledButtonText = styled(StyledButtonBase).withConfig({
  displayName: "StyledButtonText",
  componentId: "uyd427-3"
})(["border:none;background-color:transparent;color:", ";font-weight:bold;&:active{color:", ";> span{border-bottom-color:", ";}}&:disabled{color:", ";}&:not([disabled]){&:hover,&:focus{color:", ";> span{border-bottom:2px solid ", ";}}}"], colorValue('cta'), function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, colorValue('placeholder'), colorValue('ctaActive'), colorValue('ctaActive'));
var variantMap = {
  contained: StyledButtonContained,
  outlined: StyledButtonOutlined,
  text: StyledButtonText
};

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["children", "variant"]);

  var Component = variantMap[variant];
  return createElement(Component, props, createElement("span", null, children));
};

var defaultPadding = {
  xs: 6,
  md: 7
};

var applyPadding = function applyPadding(props) {
  var px = props.padding !== undefined ? props.padding : defaultPadding;
  return system({
    px: px
  });
};

var applyLimitWidth = function applyLimitWidth(props) {
  if (props.limitWidth) {
    return css(["max-width:", "px;box-sizing:content-box;> div{box-sizing:border-box;}"], props.theme.siteWidth);
  }

  return undefined;
};

var applyFree = function applyFree(props) {
  if (!props.free) {
    return css(["margin-left:auto;margin-right:auto;"]);
  }

  return undefined;
};

var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-1c4ou3g-0"
})(["", " ", " ", ""], applyPadding, applyLimitWidth, applyFree);

var Container = function Container(_ref) {
  var children = _ref.children,
      padding = _ref.padding,
      _ref$limitWidth = _ref.limitWidth,
      limitWidth = _ref$limitWidth === void 0 ? false : _ref$limitWidth,
      _ref$free = _ref.free,
      free = _ref$free === void 0 ? false : _ref$free,
      rest = _objectWithoutProperties(_ref, ["children", "padding", "limitWidth", "free"]);

  return createElement(StyledContainer, _extends({
    limitWidth: limitWidth,
    free: free,
    padding: padding
  }, rest), createElement("div", null, children));
};
/**
 * @component
 */


var Flex = styled(Box)({
  display: 'flex'
});
var COMPONENT_HEIGHT$1 = '48px';
var StyledFunButton = styled$1.button.withConfig({
  displayName: "StyledFunButton",
  componentId: "sc-1tup0la-0"
})(["", ";background-color:", ";box-shadow:inset 0 0 0 2px ", ";display:inline-flex;text-decoration:none;transform:translate(4px,4px);> span{align-items:center;background-color:white;border:2px solid ", ";color:", ";display:flex;", " height:", ";justify-content:center;padding:0 1rem;text-transform:lowercase;transform:translate(-4px,-4px);transition:transform 80ms linear;width:100%;}&:not(:disabled){&:hover > span{transform:translate(-2px,-2px);}}&:disabled{opacity:0.3;}"], sizingSpacing, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.aurora.base;
}, colorValue('text'), colorValue('text'), colorValue('text'), system({
  typography: 'ctaButton'
}), COMPONENT_HEIGHT$1);

var FunButton = function FunButton(_ref2) {
  var children = _ref2.children,
      type = _ref2.type,
      onClick = _ref2.onClick,
      _ref2$testId = _ref2.testId,
      testId = _ref2$testId === void 0 ? 'lp-component-fun-button' : _ref2$testId,
      props = _objectWithoutProperties(_ref2, ["children", "type", "onClick", "testId"]);

  return createElement(StyledFunButton, _extends({
    "data-testid": testId,
    type: type,
    onClick: onClick
  }, props), createElement("span", null, children));
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  html {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n    box-sizing: border-box;\n  }\n\n  *, *::before, *::after  {\n    box-sizing: inherit;\n  }\n\n  body {\n    background-color: ", ";\n    color: ", ";\n    margin: 0;\n    ", "\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ol, ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-indent: 0;\n  }\n\n  h1 {\n    ", "\n  }\n\n  h2 {\n    ", "\n  }\n\n  h3 {\n    ", "\n  }\n\n  h1, h2, h3, h4, h5, p {\n    margin: 0 0 1rem 0;\n  }\n\n  button {\n    border: 0;\n    border-radius: 0;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = createGlobalStyle(_templateObject(), colorValue('site'), colorValue('text'), system({
  typography: 'body'
}), colorValue('cta'), system({
  typography: 'display4'
}), system({
  typography: 'display3'
}), system({
  typography: 'display2'
}));
var defaultGap = {
  xs: 6,
  lg: 7
};

var neg = function neg(gap) {
  if (typeof gap === 'number') return -gap;
  return Object.keys(gap).reduce(function (acc, curr) {
    acc[curr] = -gap[curr];
    return acc;
  }, {});
};

var getColGap = function getColGap(_ref) {
  var gap = _ref.gap,
      colGap = _ref.colGap;
  var v = colGap || gap || 0;

  if (v && typeof v === 'boolean') {
    v = defaultGap;
  }

  return v;
};

var getRowGap = function getRowGap(_ref2) {
  var gap = _ref2.gap,
      rowGap = _ref2.rowGap;
  var v = rowGap || gap || 0;

  if (v && typeof v === 'boolean') {
    v = defaultGap;
  }

  return v;
};

var outerGap = function outerGap(props) {
  var colGap = getColGap(props);
  var rowGap = getRowGap(props);
  return system({
    ml: neg(colGap),
    mb: neg(rowGap)
  });
};

var innerGap = function innerGap(props) {
  var colGap = getColGap(props);
  var rowGap = getRowGap(props);
  return system({
    pl: colGap,
    pb: rowGap
  });
};
/**
 * @component
 */


var Grid = styled.div.withConfig({
  displayName: "Grid",
  componentId: "pq2i4-0"
})(["display:flex;flex-wrap:wrap;", ";", ";", " > *{", "}"], flexbox, spacing, outerGap, innerGap);
var StyledText = styled.span.withConfig({
  displayName: "StyledText",
  componentId: "sc-1iuaz7t-0"
})(["", ""], all);

var Text = function Text(_ref) {
  var children = _ref.children,
      _ref$typography = _ref.typography,
      typography = _ref$typography === void 0 ? 'body' : _ref$typography,
      rest = _objectWithoutProperties(_ref, ["children", "typography"]);

  return createElement(StyledText, _extends({
    typography: typography
  }, rest), children);
};

var levelMap = {
  h1: 'display4',
  h2: 'display3',
  h3: 'display2',
  h4: 'display1'
};

var Heading = function Heading(_ref) {
  var children = _ref.children,
      level = _ref.level,
      rest = _objectWithoutProperties(_ref, ["children", "level"]);

  return createElement(Text, _extends({
    typography: levelMap[level],
    as: level
  }, rest), children);
};

var Image = function Image(_ref) {
  var aspectRatio = _ref.aspectRatio,
      alt = _ref.alt,
      crossOrigin = _ref.crossOrigin,
      decoding = _ref.decoding,
      height = _ref.height,
      sizes = _ref.sizes,
      src = _ref.src,
      srcSet = _ref.srcSet,
      useMap = _ref.useMap,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, ["aspectRatio", "alt", "crossOrigin", "decoding", "height", "sizes", "src", "srcSet", "useMap", "width"]);

  var imgProps = {
    alt: alt,
    crossOrigin: crossOrigin,
    decoding: decoding,
    height: height,
    sizes: sizes,
    src: src,
    srcSet: srcSet,
    useMap: useMap,
    width: width
  };
  var imgElement = createElement("img", _extends({}, imgProps, {
    alt: imgProps.alt || ''
  }));
  return aspectRatio !== undefined ? createElement(AspectRatio, _extends({
    ratio: aspectRatio
  }, props), imgElement) : imgElement;
};
/**
 * @component
 */


var ScreenReaderOnly = styled.span.withConfig({
  displayName: "ScreenReaderOnly",
  componentId: "sc-3ptam4-0"
})(["position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;"]);
var COMPONENT_SIZE = '48px';
var StyledIconButton = styled$1.button.withConfig({
  displayName: "StyledIconButton",
  componentId: "sc-8x43rr-0"
})(["display:flex;align-items:center;justify-content:center;width:", ";height:", ";color:", ";&:hover,&:focus{color:", ";}&:active{color:", ";}&:disabled{color:", ";}"], COMPONENT_SIZE, COMPONENT_SIZE, colorValue('text'), colorValue('cta'), function (props) {
  return props.theme.colors.palette.moonpink.d80;
}, colorValue('placeholder'));

var IconButton = function IconButton(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["icon", "label"]);

  var Icon = icon;
  return createElement(StyledIconButton, _extends({}, props, {
    "aria-label": label
  }), createElement(Icon, {
    width: "28px",
    height: "28px",
    "aria-hidden": true
  }));
};

export { AspectRatio, Box, Button, Container, Flex, FunButton, GlobalStyle, Grid, Heading, IconButton, Image, ScreenReaderOnly, Text };